<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          :initial="contentTopicSponsorship.attributes"
          headline="Edit Content Topic Sponsorship"
          :errors="errors"
          :portal="portal"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/ContentTopicSponsorships/Panels/Form'
import LoadingContainer from '../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {LoadingContainer, FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      contentTopicSponsorship: null,
      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-topic-sponsorships/' + this.$route.params.contentTopicSponsorshipId).then(response => {
        this.contentTopicSponsorship = response.data.data

        this.loading = false
      })
    },

    submit(data) {
      http.put('/api/v2/content-topic-sponsorships/' + this.$route.params.contentTopicSponsorshipId, data)
          .then(() => {
            notify.success('The content topic sponsorship was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/topics/' + this.$route.params.contentTopicId + '/edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
